import React from 'react'
import { BookSellersIcons } from './Icons'
import childrenLitterature from '@assets/images/books/children_literature.png'
import comicBook from '@assets/images/books/comic_book.png'
import cooking from '@assets/images/books/cooking.png'
import foreignEssays from '@assets/images/books/foreign_essays.png'
import foreignLiterature from '@assets/images/books/foreign_literature.png'
import imaginaryLiterature from '@assets/images/books/imaginary_literature.png'
import police from '@assets/images/books/police.png'
import practicalBook from '@assets/images/books/practical_book.png'
import poetryTheater from '@assets/images/books/poetry_theater.png'
import quebecEssays from '@assets/images/books/quebec_essays.png'
import quebecLiterature from '@assets/images/books/quebec_literature.png'

interface ToolTipIconProps {
  icon: string
}

export function Icon({ icon }: ToolTipIconProps) {
  let element: React.ReactNode

  switch (icon as BookSellersIcons) {
    case BookSellersIcons.children_literature:
      element = <img src={childrenLitterature} alt="children_literature" />
      break
    case BookSellersIcons.comic_book:
      element = <img src={comicBook} alt="comic_book" />
      break
    case BookSellersIcons.cooking:
      element = <img src={cooking} alt="cooking" />
      break
    case BookSellersIcons.foreign_essays:
      element = <img src={foreignEssays} alt="foreign_essays" />
      break
    case BookSellersIcons.foreign_literature:
      element = <img src={foreignLiterature} alt="foreign_literature" />
      break
    case BookSellersIcons.imaginary_literature:
      element = <img src={imaginaryLiterature} alt="imaginary_literature" />
      break
    case BookSellersIcons.police:
      element = <img src={police} alt="police" />
      break
    case BookSellersIcons.practical_book:
      element = <img src={practicalBook} alt="practical_book" />
      break
    case BookSellersIcons.poetry_theater:
      element = <img src={poetryTheater} alt="poetry_theater" />
      break
    case BookSellersIcons.quebec_essays:
      element = <img src={quebecEssays} alt="quebec_essays" />
      break
    case BookSellersIcons.quebec_literature:
      element = <img src={quebecLiterature} alt="quebec_literature" />
      break
    default:
      element = null
  }

  return <div className="icon">{element}</div>
}
